import { ReactNode, ReactText } from 'react';

import { toast } from 'react-toastify';

import { SuccessIcon, ErrorCrossIcon, WarningIcon } from 'assets/icons';

import 'react-toastify/dist/ReactToastify.css';
import './styles.css';

const POSITION = 'top-center';
const AUTO_CLOSE_DELAY = 5000;
const style = {
  background: '#F7D2D7',
  border: '1px solid #E60225'
};
const successStyle = {
  background: '#CDEDE5',
  border: '1px solid #A3D9CC',
  color: '#136753'
};
const warningStyle = {
  background: '#FFFFF2',
  border: '1px solid #F0B90F'
};

const uniqueErrorMessages = new Set();
let clearUniqueErrorMessagesTimeout: ReturnType<typeof setTimeout> | undefined;

export const showToast = (
  message: string,
  success: boolean,
  containerId?: string,
  icon?: ReactNode
): ReactText | undefined => {
  if (!message) {
    return;
  }
  if (success) {
    return toast.success(message, {
      ...(containerId ? { containerId } : { containerId: 'default' }),
      position: POSITION,
      autoClose: AUTO_CLOSE_DELAY,
      hideProgressBar: true,
      closeButton: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: successStyle,
      icon: icon || (
        <SuccessIcon
          className='text-SUCCESS_ICON_DEFAULT'
          data-testid='successAlert'
        />
      )
    });
  } else {
    if (uniqueErrorMessages.has(message)) {
      return 0;
    }
    uniqueErrorMessages.add(message);

    if (clearUniqueErrorMessagesTimeout) {
      clearTimeout(clearUniqueErrorMessagesTimeout);
    }
    clearUniqueErrorMessagesTimeout = setTimeout(() => {
      uniqueErrorMessages.clear();
    }, AUTO_CLOSE_DELAY);

    return toast.error(message, {
      ...(containerId ? { containerId } : { containerId: 'default' }),
      position: POSITION,
      autoClose: AUTO_CLOSE_DELAY,
      hideProgressBar: true,
      closeButton: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: style,
      icon: icon || <ErrorCrossIcon className='text-ERROR justify-center' />
    });
  }
};

/** Warning toast; `sticky` keeps it open until the user closes it. */
export const showWarningToast = (
  message: string,
  sticky = false
): ReactText | undefined => {
  if (!message) {
    return;
  }
  return toast.warning(message, {
    containerId: 'default',
    position: POSITION,
    autoClose: sticky ? false : AUTO_CLOSE_DELAY,
    hideProgressBar: true,
    closeButton: sticky,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: warningStyle,
    icon: <WarningIcon className='text-DARK_YELLOW' />
  });
};
